import {IdentificadorServico} from "../utils/identificadores-servicos-api";

const requisicao = async ({ url, method = 'get', params = {}, data = null, responseType = '' } = {}) => {
  let authToken = getCookie('escavador.auth.token');
  return axios({
      method: method,
      url: url,
      params: params,
      data: data,
      responseType: responseType,
      headers: { Authorization: `Bearer ${authToken}`}
  })
};

export default {
  'GET_BY_CURSOR': (params, url) => {
    return requisicao({ url : url, params: params });
  },
  'DOWNLOAD_EXCEL': async (params) => {
    return requisicao({ url: 'playground/exportar-excel', responseType: "blob", params: params.query });
  },
  [IdentificadorServico.ENVOLVIDO_PROCESSOS]: async (params) => {
    return requisicao({ url: 'api/v2/envolvido/processos', params: params.query })
  },
  [IdentificadorServico.OAB_PROCESSOS]: async (params) => {
    return requisicao({ url: 'api/v2/advogado/processos', params: params.query })
  },
  [IdentificadorServico.CAPA_PROCESSO]: async (params) => {
    return requisicao({ url: `api/v2/processos/numero_cnj/${params.numero}`, params: params.query })
  },
  [IdentificadorServico.ATUALIZACAO_PROCESSO]: async (params) => {
    return requisicao({ url: `api/v2/processos/numero_cnj/${params.numero}/solicitar-atualizacao`, params: params.query, method: 'post',})
  },
  [IdentificadorServico.STATUS_ATUALIZACAO_PROCESSO]: async (params) => {
    return requisicao({ url: `api/v2/processos/numero_cnj/${params.numero}/status-atualizacao`, params: params.query })
  },
  [IdentificadorServico.ATUALIZACAO_PROCESSO_RESUMO_IA]: async (params) => {
    return requisicao({ url: `api/v2/processos/numero_cnj/${params.numero}/ia/resumo/solicitar-atualizacao`, params: params.query, method: 'post' })
  },
  [IdentificadorServico.PROCESSO_RESUMO_IA]: async (params) => {
    return requisicao({ url: `api/v2/processos/numero_cnj/${params.numero}/ia/resumo`, params: params.query })
  },
  [IdentificadorServico.STATUS_RESUMO_INTELIGENTE]: async (params) => {
    return requisicao({ url: `api/v2/processos/numero_cnj/${params.numero}/ia/resumo/status`, params: params.query })
  },
  [IdentificadorServico.PROCESSO_MOVIMENTACOES]: async (params) => {
    return requisicao({ url: `api/v2/processos/numero_cnj/${params.numero}/movimentacoes`, params: params.query })
  },
}
